import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { CoreModule } from "../core/core.module";
import { ReferralProgramsListComponent } from "./programs/programs-list.component";
import { ReferralProgramsEditComponent } from "./programs/programs-edit.component";
import { ReferralRewardsListComponent } from "./rewards/rewards-list.component";
import { ReferralRewardsEditComponent } from "./rewards/rewards-edit.component";
import { ReferralsService } from "./referrals.service";
import { RouterModule } from "@angular/router";

@NgModule({
  imports: [
    CommonModule,
    CoreModule,
    FormsModule,
    RouterModule,
  ],
  exports: [
    ReferralProgramsListComponent,
    ReferralProgramsEditComponent,
    ReferralRewardsListComponent,
    ReferralRewardsEditComponent,
  ],
  providers: [ReferralsService],
  declarations: [
    ReferralProgramsListComponent,
    ReferralProgramsEditComponent,
    ReferralRewardsListComponent,
    ReferralRewardsEditComponent,
  ],
})
export class ReferralsModule {}



// WEBPACK FOOTER //
// /home/runner/_work/monorepo/monorepo/admin-portal-old/src/app/referrals/referrals.module.ts